import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { changeFromName } from 'actions/tasks'
import Field from 'components/theme/Field'

const FromName = ({ changeFromName, disabled }) => {
  return (
    <div>
      <Field
        disabled={disabled}
        label="Sender name"
        property="fromName"
        // handleChangeFuncPath="actions/template"
        // handleChangeFunc="setImageDimension"
        handleChange={(prop, val) => changeFromName(val)}
        valuePath={state => state.tasks.addOrEdit.fromName}
      />
    </div>
  )
}

export default connect(
  state => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )
    return { disabled }
  },
  dispatch => bindActionCreators({ changeFromName }, dispatch),
)(FromName)
